import { SpecialtyDefinition } from "./specialtyDefinitionModels";
import SpecialtyDefinitionService from "./specialtyDefinitionService";

export {
  SpecialtyDefinition,
  SpecialtyDefinitionService,
};
